import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * Shown while a tester has not finished the 5-step profile/KYC onboarding.
 * Soft-gate companion: they can use Academy, User Guide, and Support Chat.
 */
export default function TesterProfileIncompleteBanner({ sx }) {
  const { user } = useSelector((state) => state.auth);
  if (!user || user.role !== 'tester' || user.profileCompleted) return null;

  return (
    <Box
      sx={{
        p: 1.5,
        mb: 2,
        borderRadius: '8px',
        bgcolor: '#fff7ed',
        border: '1px solid #fed7aa',
        ...sx,
      }}
    >
      <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#9a3412', mb: 0.5 }}>
        Complete profile
      </Typography>
      <Typography sx={{ fontSize: 12, color: '#9a3412', lineHeight: 1.5 }}>
        Finish personal info, devices, NDA, and identity so we can match you to paid cycles.
        Academy, User Guide, and Support are available now.{' '}
        <Box
          component={RouterLink}
          to="/tester-complete-profile"
          sx={{ color: 'inherit', fontWeight: 800, textDecoration: 'underline' }}
        >
          Complete profile
        </Box>
      </Typography>
    </Box>
  );
}
